<template>
    <div>
        <FiltrosContratos :filter-data="filterData" :id-carrinho="idCarrinho" :is-draft="true" @filter="controleFiltrosRascunhos" />

        <Listagem @atualizaFiltroCarrinho="onAtualizaFiltroCarrinho" :filter="filter" :custom-filter="customFilter" :somente-rascunho="true" />
    </div>
</template>

<script>
  import FiltrosContratos from '@/components/contratos/FiltrosContratos.vue'
  import Listagem from '@/views/painel/contratos/Listagem.vue'
  import { DEFAULT_CUSTOM_FILTER, DEFAULT_FILTER } from '../../../enums/contratos/defaultFilters'

  export default {
    name: 'Rascunhos',
    components: {
      FiltrosContratos,
      Listagem
    },
    props: {
      filterData: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => {
      return {
        filter: {
          ...DEFAULT_FILTER
        },
        customFilter: {
          ...DEFAULT_CUSTOM_FILTER
        },
        idCarrinho: ''
      }
    },

    methods: {
      controleFiltrosRascunhos (filters) {
        this.filter = filters.filter
        this.customFilter = filters.custom_filter
      },
      onAtualizaFiltroCarrinho (idCarrinho) {
        this.idCarrinho = idCarrinho
      }
    }
  }
</script>
